import React from 'react';
import {TechseeBaseComponent} from '@techsee/techsee-ui-common/lib/_shared/techsee-base-component';
import {LeftBar} from './leftBar/LeftBar';
import {observer} from 'mobx-react';
import {Main} from './main/Main';

import './liveDashboardLayoutStyles.scss';
import {TopBar} from './topBar/ToptBar';
import {EndMeetingModal} from './endMeetingModal/EndMeetingModal';
import {MultipartyDashboardController} from '../../../MultipartyDashboardController';
import {CustomerEndedTheMeetingModal} from './customerEndedTheMeetingModal/CustomerEndedTheMeetingModal';
import {ClientWebRtcNotSupportedModal} from './clientWebRtcNotSupportedModal/ClientWebRtcNotSupportedModal';
import {RightBar} from './rightBar/RightBar';
import {NwayFloatingToolbar, ToolbarHost} from '../../FloatingToolbar/NwayFloatingToolbar';
import {Toast} from '../../../../../../components/toast/Toast';
import {NwayJoinRequestBanner} from '../NwayJoinRequestBanner';
import {WaitingForHost} from '@techsee/techsee-nway-media-service-client/lib/components/WaitingForHost/WaitingForHost';

type LiveDashboardLayoutProps = {
    controller: MultipartyDashboardController;
};

@observer
export class LiveDashboardLayout extends TechseeBaseComponent<LiveDashboardLayoutProps> {
    renderInternal(): JSX.Element {
        const {controller} = this.props;

        if (controller.waitingForHostApproval) {
            return (
                <WaitingForHost
                    message={controller.translate('REACT.NWAY.WAITING_FOR_HOST')}
                    logoUrl={controller.logoUrl}
                    poweredByLabel={controller.translate('DASHBOARD.VIEW.POWERED_BY_TECHSEE')}
                />
            );
        }

        return (
            <div className='live-dashboard-root-layout'>
                <EndMeetingModal />
                <CustomerEndedTheMeetingModal />
                <ClientWebRtcNotSupportedModal />

                <TopBar />
                <div className='live-dashboard-middle-area'>
                    <LeftBar />
                    <div className='live-dashboard-main-content'>
                        <Main controller={controller} />
                        <NwayJoinRequestBanner controller={controller} className='live-dashboard-join-requests'>
                            <Toast message={controller.notificationMessage} duration={5000} />
                        </NwayJoinRequestBanner>
                    </div>
                    {controller.showGallery && <RightBar />}
                </div>
                {!controller.isParticipant && <NwayFloatingToolbar controller={controller as ToolbarHost} />}
            </div>
        );
    }
}
